import { render } from "./AwardDetailMay2025Page.vue?vue&type=template&id=d289d90a"
import script from "./AwardDetailMay2025Page.vue?vue&type=script&lang=js"
export * from "./AwardDetailMay2025Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__